import { HeadingProps } from "../../types";

const Heading: React.FC<HeadingProps> = (props) => {
  const { title, text } = props;
  return (
    <>
      <h1 className="text-content-primary text-2xl font-bold max-md:text-xl">
        {title}
      </h1>
      {text && <p className="text-content-tertiary mt-3 text-sm">{text}</p>}
    </>
  );
};

export default Heading;
